<template>
  <div>
    <Loading v-if="loading" />
    <div style="display:flex;gap:20px;">
      <!-- Left -->
      <div style="flex-basis:50%;">
        <!-- Search for contact -->
        <div v-if="!selectedContact" style="margin-bottom:20px;">
          <FormulateForm @submit="search">
            <FormulateInput
              type="text"
              v-model="query"
              label="Search contacts by email"
              validation="required"
              placeholder="e.g. janedoe@superiorpress.com"
              error-behavior="submit"
            />
            <FormulateInput type="submit" name="Search" />
          </FormulateForm>

          <div v-if="searchedOnce" style="margin-top: 30px;">
            <div
              v-if="searchResults.length"
              class="cards"
              style="max-width: 600px"
            >
              <div
                v-for="result in searchResults"
                :key="result.id"
                class="card"
                @click="selectContact(result)"
              >
                <div style="font-size:18px;font-weight:bold;">
                  {{ result.properties.firstname }}
                  {{ result.properties.lastname }}
                </div>
                <div
                  v-if="result.properties.company"
                  style="margin-bottom:5px;opacity:80%;"
                >
                  {{ result.properties.company }}
                </div>
                <div style="font-size:14px;">{{ result.properties.email }}</div>
              </div>
            </div>
            <div v-else>No contacts found.</div>
          </div>
        </div>
        <!-- Form -->
        <div>
          <FormulateForm @submit="createTicket">
            <FormulateInput
              type="text"
              v-model="sendData.contact.firstname"
              label="First name"
              placeholder="e.g. John"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput
              type="text"
              v-model="sendData.contact.lastname"
              label="Last name"
              placeholder="e.g. Smith"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput
              type="email"
              v-model="sendData.contact.email"
              label="Email"
              placeholder="e.g. example@gmail.com"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput
              type="text"
              v-model="sendData.contact.phone"
              label="Phone number"
              placeholder="e.g. 123 456 78"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput
              type="text"
              v-model="sendData.contact.company"
              label="Company name"
              placeholder="e.g. Acme Limited"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput
              v-for="field in bookingFields"
              :key="field.hubspot_property_id"
              :type="field.type"
              :options="
                field.fetchOptions
                  ? apidata.metadata.options[field.hubspot_property_id].options
                  : field.options
              "
              v-model="sendData.ticket[field.hubspot_property_id]"
              :label="field.label"
              validation="required"
              error-behavior="submit"
            />
            <FormulateInput type="submit" name="Create ticket" />
          </FormulateForm>
        </div>
      </div>
      <!-- Right -->
      <div style="flex-basis:50%;">
        <!-- Preview contact -->
        <div
          style="padding:10px;border:1px solid lightgrey;border-radius:5px;min-height:500px;"
        >
          <div v-if="selectedContact">
            <!-- Details -->
            <div>
              <div style="margin-bottom:10px;">
                <div style="font-size:18px;font-weight:bold;">
                  {{ selectedContact.properties.firstname }}
                  {{ selectedContact.properties.lastname }}
                </div>
                <div
                  v-if="selectedContact.properties.company"
                  style="margin-bottom:5px;opacity:80%;"
                >
                  {{ selectedContact.properties.company }}
                </div>
                <div style="font-size:14px;">
                  {{ selectedContact.properties.email }}
                </div>
              </div>
              <button @click="selectedContact = null">
                Search for another contact
              </button>
            </div>
            <!-- Associations -->
            <div
              style="margin-top:20px;padding-top:20px;border-top:1px solid lightgrey;"
            >
              <div v-if="selectedContactMetadata">
                <div style="margin-bottom:10px;">
                  <div
                    v-if="
                      selectedContactMetadata.bookings &&
                        selectedContactMetadata.bookings.length
                    "
                  >
                    <div
                      v-for="booking in selectedContactMetadata.bookings"
                      :key="booking.id"
                      class="cards"
                    >
                      <div
                        @click="selectTicket(booking.ticket_id)"
                        class="card"
                      >
                        <strong>Booking</strong>:
                        {{
                          moment(booking.from)
                            .utc()
                            .format("YYYY-MM-DD [at] HH:mm [UTC]")
                        }}
                      </div>
                    </div>
                  </div>
                  <div v-else>No bookings found.</div>
                </div>
                <div
                  v-if="
                    selectedContactMetadata.tickets &&
                      selectedContactMetadata.tickets.length
                  "
                >
                  <div
                    v-for="ticket in selectedContactMetadata.tickets"
                    :key="ticket.id"
                    class="cards"
                  >
                    <div @click="selectTicket(ticket.id)" class="card">
                      <strong>Ticket</strong>: {{ ticket.properties.subject }}
                    </div>
                  </div>
                </div>
                <div v-else>No tickets found.</div>
              </div>
              <div v-else>Loading...</div>
            </div>
          </div>
          <div v-else style="opacity:50%;">
            Select a contact to show details, bookings and tickets.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  data: function() {
    return {
      loading: null,
      searchResults: [],
      query: null,
      searchedOnce: false,
      selectedContact: null,
      selectedContactMetadata: null,
      moment,
      sendData: {
        contact: {},
        ticket: {},
      },
    };
  },

  methods: {
    search: async function() {
      try {
        this.loading = true;
        this.searchedOnce = true;
        const response = await this.$axios({
          method: "post",
          url: "https://enw8cabh8oqzey7.m.pipedream.net",
          data: {
            query: this.query,
          },
        });

        this.searchResults = response.data;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    selectContact: async function(contact) {
      this.selectedContactMetadata = null;
      this.selectedContact = contact;
      this.sendData.contact = {
        firstname: contact.properties.firstname,
        lastname: contact.properties.lastname,
        phone: contact.properties.phone,
        company: contact.properties.company,
        email: contact.properties.email,
      };
      try {
        const response = await this.$axios({
          method: "get",
          url: "https://enc0s9i6t2lsp8k.m.pipedream.net",
          params: {
            contact_id: contact.id,
            system_id: this.apidata.system.system_id,
            pipeline_id: this.apidata.system.ticket_pipeline_id,
          },
        });

        this.selectedContactMetadata = response.data;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      }
    },
    selectTicket: async function(ticket_id) {
      const routeData = this.$router.resolve(`/tickets/${ticket_id}`);
      window.open(routeData.href, "_blank");
    },
    createTicket: async function() {
      try {
        this.loading = true;

        const response = await this.$axios({
          method: "post",
          // https://pipedream.com/@esminbound/superior-press-tac-create-ticket-p_ljCOA7g/edit
          url: "https://enmk4tidxflaakq.m.pipedream.net",
          data: {
            contact: {
              ...this.sendData.contact,
            },
            ticket: {
              ...this.sendData.ticket,
              hs_pipeline: this.apidata.system.ticket_pipeline_id,
              hs_pipeline_stage: this.apidata.system.ticket_scheduled_status_id,
              rep_contact_id: this.apidata.me.id,
              source_type: "PHONE",
            },
          },
        });
        this.$toast.success("Ticket created.");
        this.selectTicket(response.data.ticket_id);
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created: async function() {},

  computed: {
    bookingFields: function(){ 
      const fields = this.apidata.system.booking_fields
      const array = []
      for (const field of fields) {
        if (field.conditions) {
          for (const condition of field.conditions) {
            if (this.sendData.ticket[condition.hubspot_property_id] === condition.equals) {
              array.push(field)
            }
          }
        } else {
          array.push(field)
        }
      }
      return array
    }
  }
};
</script>

<style scoped>
.statuses {
  display: flex;
}

.status {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid lightgrey;
  padding: 10px;
  overflow: auto;
  text-align: center;
}

.status h4 {
  font-size: 12.5px;
}

.status:first-child {
  border-left: 1px solid lightgrey;
}

.tickets {
  height: 600px;
  margin-top: 20px;
  width: 100%;
}

.contact {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 25px;
  border-bottom: 1px solid rgb(201, 201, 201);
  align-items: center;
  margin-right: 20px;
}

.contact h4 {
  color: var(--primary-color);
}

.contact div {
  margin-bottom: 5px;
}

.contact .left {
  margin-right: 10px;
}

.contacts {
  max-height: 400px;
  overflow: auto;
}

.ticket-info:not(:first-child) {
  border-left: 4px solid var(--primary-color);
  padding-left: 5px;
  margin-top: 5px;
}

.mini-label {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12px;
  color: grey;
}

.mini-label:not(:first-child) {
  margin-top: 20px;
}

input[type="checkbox"] {
  transform: scale(1.5);
}
</style>
